import { Timespan } from './timespan';

export { Timespan };

export default Timespan;
